// extracted by mini-css-extract-plugin
export default {"box":"SubTitle_box__zepkr","box__title":"SubTitle_box__title__VZ-j9","box__border_top":"SubTitle_box__border_top__j9-rL"};